const icon = new URL('../../icons/backdrop.png', import.meta.url).href

export default {
  type: 'backdrop',
  description: '3D scene backdrop — 6-sided envelope (4 walls + floor + ceiling)',
  group: ['etc'],
  icon,
  model: {
    type: 'backdrop',
    top: 0,
    left: 0,
    width: 3000,
    height: 2400,
    // depth seeded on creation as min(width, height) by Backdrop's
    // `_syncFromRoot(seedDepth=true)`. Editable via property panel
    // afterward — board-resize syncs won't override it.
    fitToBoard: true,
    alpha: 1,
    // 6면 합성 상태. 비어있으면 backdrop 컴포넌트의 default 가 적용됨
    // (벽 4면 = #dde2e8/0.35, 바닥 = #9c9c9c/1.0, 천장 = #e8e8ec/1.0).
    faces: {
      east: { fillStyle: '#dde2e8', visible: true, alpha: 0.35 },
      west: { fillStyle: '#dde2e8', visible: true, alpha: 0.35 },
      north: { fillStyle: '#dde2e8', visible: true, alpha: 0.35 },
      south: { fillStyle: '#dde2e8', visible: true, alpha: 0.35 },
      floor: { fillStyle: '#9c9c9c', visible: true, alpha: 1.0 },
      ceiling: { fillStyle: '#e8e8ec', visible: true, alpha: 1.0 }
    }
  }
}
